import React, { useCallback, useEffect, useRef, useState } from "react";
import { AddProjectLightIcon, CloseIcon } from "../../Assest/icons/icons";
import UploadHistoryModal from "../modals/UploadHistoryModal";
import axios from "axios";
import { UnoStoreHooks } from "@simulanisindia/ui";
import { assestType, resourcePlatforms } from "../../utils/constants/common";
import { UPLOAD_ASSET, ASSEST_CREATE_VERSION, RESOURCE_ASSEST_LIST_VERSION } from "../../apiClient/apiEndpoints";
import apiClient from "../../apiClient";

const { useUnoSelector } = UnoStoreHooks;

const ModuleUploadAssets = ({ id }) => {
  const configData = useUnoSelector((state) => state.config);
  const UNO_URL = configData.config.UNO_URL;
  const platformOptions = resourcePlatforms;
  const [platform, setPlatform] = useState(platformOptions[0]);
  const [fileType, setFileType] = useState(assestType[0]);
  const [dragActive, setDragActive] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadResponse, setUploadResponse] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [comment, setComment] = useState("");
  const fileInputRef = useRef(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState({});

  const handlePlatformChange = (option) => {
    setPlatform(option);
    setSelectedFile(null);
    setUploadResponse(null);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") setDragActive(true);
    else if (e.type === "dragleave") setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer?.files?.length) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleFileInput = (e) => {
    if (e.target.files?.length) {
      handleFile(e.target.files[0]);
    }
  };

  const handleFile = async (file) => {
    setSelectedFile({ file, name: file.name, size: file.size, status: "pending" });
    setUploading(true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(`${UNO_URL}${UPLOAD_ASSET}/${platform.key}/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setSelectedFile((prev) => ({ ...prev, status: "uploaded" }));
      setUploadResponse(response?.data?.url);
      setError((prev) => ({ ...prev, assetLink: "" }));
    } catch (err) {
      console.error("Upload failed:", err.response?.data || err.message);
      setSelectedFile((prev) => ({ ...prev, status: "failed" }));
    } finally {
      setUploading(false);
    }
  };

  const removeFile = () => {
    setSelectedFile(null);
    setUploadResponse(null);
  };

  const formatFileSize = (bytes) => {
    if (!bytes && bytes !== 0) return "";
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const validateUpload = () => {
    const newError = {};
    if (!comment?.trim()) newError.comment = "Comment is required";
    if (!uploadResponse) newError.assetLink = " Upload File is required";
    if (Object.values(newError).length) {
      setError(() => newError);
      return false;
    }
    setError(() => {});
    return true;
  };

  const handleAssesUpload = async () => {
    try {
      if (!validateUpload()) return;
      setSaving(true);
      const payload = {
        assetLink: uploadResponse,
        comment: comment,
        embedLink: null,
        platform: platform.key,
        type: fileType.key,
      };
      await apiClient.post(`${UNO_URL}${ASSEST_CREATE_VERSION}/${platform.key}/${id}`, payload);
    } catch (error) {
      console.log(error.message);
    } finally {
      setSaving(false);
    }
  };

  const fetResourceListVersion = async () => {
    try {
      const response = await apiClient.get(`${UNO_URL}${RESOURCE_ASSEST_LIST_VERSION}/${platform.key}/${id}`);
      const assetLink = response[0]?.data?.assetLink;
      if (assetLink) {
        const fileDetail = await getFileMeta(assetLink);
        setUploadResponse(assetLink);
        setSelectedFile(fileDetail);
        setComment(response[0]?.data?.comment);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getFileMeta = async (url) => {
    try {
      const response = await axios.head(url);
      const size = response.headers["content-length"];
      const name = url.split("/").pop();
      return { name, size, status: "uploaded" };
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetResourceListVersion();
    setComment("");
    removeFile();
  }, [platform.key]);

  return (
    <div className="assetsPage">
      {/* Platform Selection */}
      <div className="platformSelect basicSelect">
        <div className="inputItem">
          <p>
            Select Platform<span> *</span>
          </p>
          <div className="level-buttons">
            {platformOptions.map((option) => (
              <button
                key={option.key}
                type="button"
                className={`btn ${platform.key === option.key ? "btn-danger" : "btn-outline-danger"}`}
                onClick={() => handlePlatformChange(option)}
              >
                {option.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* <div className="platformSelect basicSelect mt-3">
        <div className="inputItem">
          <p>
            Select File Type<span> *</span>
          </p>
          <div className="level-buttons">
            {fileTypeOptions.map((option) => (
              <button
                key={option.key}
                type="button"
                className={`btn ${fileType.key === option.key ? "btn-danger" : "btn-outline-danger"}`}
                onClick={() => setFileType(option)}
              >
                {option.name}
              </button>
            ))}
          </div>
        </div>
      </div> */}

      <div className="platformSelect basicSelect mt-3">
        <div className="inputItem">
          <div className="d-flex align-items-center justify-content-between">
            <p>
              Upload File <span>* {error?.assetLink}</span>
            </p>
            {/* <p className="clickable" onClick={() => setShowHistory(true)}>
              Upload History
            </p> */}
          </div>
          <div
            className={`upload-drop-zone ${dragActive ? "drag-active" : ""}`}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
            onClick={() => fileInputRef.current?.click()}
          >
            <input type="file" ref={fileInputRef} onChange={handleFileInput} accept="*/*" style={{ display: "none" }} />
            <div className="upload-icon">
              <AddProjectLightIcon />
            </div>
            <p className="upload-text">drag & drop or choose file to upload</p>
          </div>

          {selectedFile && (
            <div className="uploaded-files-section mt-3">
              <div className="card d-flex flex-row align-items-center p-2 mb-2 shadow-sm">
                <div
                  className="file-preview d-flex align-items-center justify-content-center bg-light rounded-circle me-3"
                  style={{ width: "50px", height: "50px" }}
                >
                  <AddProjectLightIcon />
                </div>
                <div className="file-info flex-grow-1">
                  <p className="mb-0 fw-semibold">{selectedFile.name}</p>
                  <small className="text-muted">{formatFileSize(selectedFile.size)}</small>
                  <span
                    className={`badge ms-2 ${
                      selectedFile.status === "uploaded"
                        ? "bg-success"
                        : selectedFile.status === "failed"
                        ? "bg-danger"
                        : "bg-secondary"
                    }`}
                  >
                    {selectedFile.status}
                  </span>
                </div>
                <button type="button" className="btn btn-sm btn-outline-danger ms-3" onClick={removeFile}>
                  <CloseIcon />
                </button>
              </div>
            </div>
          )}

          <div className="inputItem mt-3">
            <p>
              Comment <span>* {error?.comment}</span>
            </p>
            <textarea
              className="form-control"
              rows="3"
              placeholder="Comment"
              value={comment}
              onChange={(e) => {
                if (comment.length < 1) setError((prev) => ({ ...prev, comment: "" }));
                setComment(e.target.value);
              }}
            />
          </div>
          <div className="modalFooterB mt-2">
            <button className="cancel">Clear</button>
            <button className="save" onClick={handleAssesUpload}>
              {saving ? "Uploading..." : "Upload"}
            </button>
          </div>
        </div>
      </div>

      {/* <UploadHistoryModal show={showHistory} handleClose={() => setShowHistory(false)} rows={historyRows} /> */}
    </div>
  );
};

export default ModuleUploadAssets;
